// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/base.min.css
// module id = 427
// module chunks = 11